export const joinUrl = (base, path) => {
  const normalizedBase = base === '/' ? '' : String(base || '').replace(/\/+$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}` || normalizedPath;
};

export const getMenuConfig = ({ mainUrl, docsUrl }) => ({
  navigation: [{ label: 'Pricing', href: joinUrl(mainUrl, '/pricing') }],
  solutions: {
    label: 'Solutions',
    sections: [
      {
        title: 'Platform Offerings',
        items: [
          {
            label: 'EU Pay Transparency Directive',
            href: joinUrl(mainUrl, '/solutions#eu-pay-transparency-directive'),
          },
          { label: 'Global Pay Gap Reporting', href: joinUrl(mainUrl, '/solutions#global-pay-gap-reporting') },
          {
            label: 'Equal Pay Regression Modeling',
            href: joinUrl(mainUrl, '/solutions#equal-pay-regression-modeling'),
          },
          {
            label: 'Compensation Analysis Consulting',
            href: joinUrl(mainUrl, '/solutions#compensation-analytics-consulting'),
          },
        ],
      },
      {
        title: 'Intelligent Features',
        items: [
          { label: 'Competitive Intelligence', href: joinUrl(mainUrl, '/solutions#competitive-intelligence') },
          { label: 'Machine Learning & AI', href: joinUrl(mainUrl, '/solutions#machine-learning-ai') },
          { label: 'Security', href: joinUrl(mainUrl, '/solutions#security') },
          { label: 'Data Integrations', href: joinUrl(mainUrl, '/solutions#data-integrations') },
        ],
      },
    ],
  },
  resources: {
    label: 'Resources',
    variant: 'docs',
    sections: [
      {
        title: 'Blogs',
        titleHref: joinUrl(docsUrl, '/news'),
        mobileTitleClassName: 'text-[14px]',
        items: [
          {
            label: 'EU Pay Transparency',
            href: joinUrl(docsUrl, '/news/tags/eu-pay-transparency-directive/'),
            flag: 'eu-circle',
          },
          { label: 'US Pay Transparency', href: joinUrl(docsUrl, '/news/tags/us-pay-transparency-laws'), flag: 'us' },
        ],
      },
      {
        title: 'Country Guides',
        layout: 'inline',
        items: [
          {
            label: 'Australia',
            href: joinUrl(docsUrl, '/countries/australia-wgea-gender-pay-reports-due-may-31'),
            flag: 'au',
          },
          { label: 'Canada', href: joinUrl(docsUrl, '/countries/canada-pay-transparency-reporting'), flag: 'ca' },
          {
            label: 'Denmark',
            href: joinUrl(docsUrl, '/countries/denmark-pay-transparency-reporting-eu-directive'),
            flag: 'dk',
          },
          {
            label: 'France',
            href: joinUrl(docsUrl, '/countries/france-pay-transparency-reporting-eu-directive'),
            flag: 'fr',
          },
          {
            label: 'Germany',
            href: joinUrl(docsUrl, '/countries/germany-pay-transparency-reporting-eu-directive'),
            flag: 'de',
          },
          { label: 'Iceland', href: joinUrl(docsUrl, '/countries/iceland-pay-transparency-reporting'), flag: 'is' },
          {
            label: 'Ireland',
            href: joinUrl(docsUrl, '/countries/ireland-pay-transparency-reporting-eu-directive'),
            flag: 'ie',
          },
          {
            label: 'Italy',
            href: joinUrl(docsUrl, '/countries/italy-pay-transparency-reporting-eu-directive'),
            flag: 'it',
          },
          {
            label: 'Netherlands',
            href: joinUrl(docsUrl, '/countries/netherlands-pay-transparency-reporting-eu-directive'),
            flag: 'nl',
          },
          { label: 'Norway', href: joinUrl(docsUrl, '/countries/norway-pay-transparency-reporting'), flag: 'no' },
          {
            label: 'Spain',
            href: joinUrl(docsUrl, '/countries/spain-pay-transparency-reporting-eu-directive'),
            flag: 'es',
          },
          {
            label: 'Sweden',
            href: joinUrl(docsUrl, '/countries/sweden-pay-transparency-reporting-eu-directive'),
            flag: 'se',
          },
          {
            label: 'Switzerland',
            href: joinUrl(docsUrl, '/countries/switzerland-pay-transparency-reporting'),
            flag: 'ch',
          },
          { label: 'UK', href: joinUrl(docsUrl, '/countries/uk-pay-transparency-reporting'), flag: 'gb' },
        ],
      },
      {
        title: 'EU Directives',
        items: [
          {
            label: 'EU Pay Transparency Directive',
            href: joinUrl(docsUrl, '/eu-pay-transparency-directive'),
            flag: 'eu-circle',
          },
          {
            label: 'EU Corporate Sustainability Reporting Directive',
            href: joinUrl(docsUrl, '/eu-corporate-sustainability-reporting-directive'),
            flag: 'eu-circle',
          },
        ],
      },
      {
        title: 'Terms & Conditions',
        items: [
          { label: 'Privacy Policy', href: joinUrl(docsUrl, '/legal/privacy-policy') },
          { label: 'Security Statement', href: joinUrl(docsUrl, '/legal/security-statement') },
          { label: 'Terms of Use', href: joinUrl(docsUrl, '/legal/terms-of-use') },
        ],
      },
      {
        title: 'References',
        titleHidden: true,
        items: [{ label: 'Compensation Glossary', href: joinUrl(docsUrl, '/glossary') }],
      },
    ],
  },
  company: {
    label: 'About Us',
    title: 'About Us',
    items: [
      { label: 'Meet the Team', href: joinUrl(mainUrl, '/about') },
      { label: 'Contact Us', href: joinUrl(mainUrl, '/contact') },
    ],
  },
});
